import { LogHelper } from 'com-gyf-webcore-loghelper';

/**
 * Importaci�n de las Actions.
 */
import {
    GET_SCREEN_DATA_PERMISOSMASIVOS_STARTS,
    SET_USER_FUNCTIONS_PERMISOSMASIVOS,
    GET_SCREEN_DATA_PERMISOSMASIVOS_SUCCESS,
    RESET_STATE_PERMISOSMASIVOS,
    REDIRECT_OK_PERMISOSMASIVOS,
    ELIMINAR_PERFIL_PERMISOSMASIVOS,
    GUARDAR_PERFILES_PERMISOSMASIVOS,
    AGREGAR_USUARIO_PERMISOSMASIVOS,
    ELIMINAR_USUARIO_PERMISOSMASIVOS,
    AGREGAR_PERMISO_PERMISOSMASIVOS,
    ELIMINAR_PERMISO_PERMISOSMASIVOS,
    SELECT_PRODUCTO_PERMISOSMASIVOS,
    SELECT_CATEGORIA_PERMISOSMASIVOS,
    SELECT_PROGRAMA_PERMISOSMASIVOS,
    AGREGAR_TODASFUNCIONES_PERMISOSMASIVOS,
    ELIMINAR_TODASFUNCIONES_PERMISOSMASIVOS,
    AGREGAR_FUNCION_PERMISOSMASIVOS,
    ELIMINAR_FUNCION_PERMISOSMASIVOS,
    SAVE_PERMISOS_RESULT_PERMISOSMASIVOS,
    SET_ERROR_MESSAGES_PERMISOSMASIVOS,
    ESCONDER_POPUP_PERMISOSMASIVOS,
    MOSTRAR_MAS_PERFILES_PERMISOS_MASIVOS,
    MOSTRAR_MENOS_PERFILES_PERMISOS_MASIVOS,
    OPEN_MODAL_PERMISOS_NO_ASIGNADOS
} from '../../Screens/PermisosMasivos/actions/PermisosMasivos';

/**
 * Estado inicial.
 */
const initialState = {
    isFetching: true,
    redirect: false,

    //Funciones de seguridad
    functions: [],

    productos: [],
    categorias: [],
    programas: [],
    funciones: [],

    //Todos los perfiles/usuarios
    perfiles: [],
    usuarios: [],

    //Perfiles/usuarios seleccionados
    perfilesSeleccionados: [],
    usuariosSeleccionados: [],

    permisos: [],

    //Mensajes de error y PopUp
    errorMessagePerfilesUsuarios: "",
    errorMessageFunciones: "",
    message: "",
    messageClass: "",
    messageHidden: true,

    showProfiles: false,
    openModalPermisosNoAsignados: false,
};

/**
 * Variables globales
 */
let result, estado, funciones, indexToRemove;

/**
 * Reduce store
 * @param {any} state
 * @param {any} action
 */
function permisosMasivos(state = initialState, action) {
    switch (action.type) {
        case GET_SCREEN_DATA_PERMISOSMASIVOS_STARTS:
            LogHelper.In(permisosMasivos.name, action, state);

            result = {
                ...state,
                isFetching: true
            };
            break;

        case SET_USER_FUNCTIONS_PERMISOSMASIVOS:
            LogHelper.In(permisosMasivos.name, action, state);

            result = {
                ...state,
                functions: action.functions
            };
            break;

        case GET_SCREEN_DATA_PERMISOSMASIVOS_SUCCESS:
            LogHelper.In(permisosMasivos.name, action, state);

            sessionStorage.setItem('PantallaCambios', false);

            result = {
                ...state,
                perfiles: action.result.GET_PERFILES,
                usuarios: action.result.GET_ALL_USERLOGINS_ABLE,
                productos: action.result.GET_PRODUCTOS,
                categorias: action.result.GET_CATEGORIAS,
                programas: action.result.GET_PROGRAMAS,
                funciones: action.result.GET_FUNCTIONS_BY_PERMISSION,
                permisos: action.result.permisos,
                productos: action.result.GET_PRODUCTOS,
                perfilesSeleccionados: [],
                usuariosSeleccionados: [],
                isFetching: false
            };
            break;

        case RESET_STATE_PERMISOSMASIVOS:
            LogHelper.In(permisosMasivos.name, action, state);

            result = initialState;
            break;

        case REDIRECT_OK_PERMISOSMASIVOS:
            LogHelper.In(permisosMasivos.name, action, state);

            result = {
                ...state,
                redirect: true
            };
            break;

        case ELIMINAR_PERFIL_PERMISOSMASIVOS:
            LogHelper.In(permisosMasivos.name, action, state);

            estado = JSON.parse(JSON.stringify(state));
            estado.perfilesSeleccionados.splice(estado.perfilesSeleccionados.findIndex(
                x => x.Id == action.idPerfil), 1);

            result = {
                ...state,
                perfilesSeleccionados: estado.perfilesSeleccionados
            };
            break;

        case GUARDAR_PERFILES_PERMISOSMASIVOS:
            LogHelper.In(permisosMasivos.name, action, state);

            sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                perfilesSeleccionados: action.perfilesSeleccionados
            };
            break;

        case AGREGAR_USUARIO_PERMISOSMASIVOS:
            LogHelper.In(permisosMasivos.name, action, state);

            estado = JSON.parse(JSON.stringify(state));
            let usuarioSelecionado = estado.usuarios.find(x => x.Login == action.login);
            estado.usuariosSeleccionados.push(usuarioSelecionado);

            estado.usuarios.forEach(function (item) {
                if (item.Login == action.login) {
                    item.Eliminado = true;
                }

            });


            let usuariosAcodatos = estado.usuarios;

            sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                usuarios: usuariosAcodatos,
                usuariosSeleccionados: estado.usuariosSeleccionados,
                errorMessagePerfilesUsuarios: ""
            };
            break;

        case ELIMINAR_USUARIO_PERMISOSMASIVOS:
            LogHelper.In(permisosMasivos.name, action, state);

            estado = JSON.parse(JSON.stringify(state));
            estado.usuariosSeleccionados.splice(estado.usuariosSeleccionados.findIndex(
                x => x.Login == action.login), 1);

            estado.usuarios.forEach(function (item) {
                if (item.Login == action.login) {
                    item.Eliminado = false;
                }
            });

            sessionStorage.setItem('PantallaCambios', true);

            let newUsuarios = estado.usuarios;
            result = {
                ...state,
                usuariosSeleccionados: estado.usuariosSeleccionados,
                usuarios: newUsuarios
            };
            break;

        case AGREGAR_PERMISO_PERMISOSMASIVOS:
            LogHelper.In(permisosMasivos.name, action, state);

            sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                permisos: action.permisos
            };
            break;

        case ELIMINAR_PERMISO_PERMISOSMASIVOS:
            LogHelper.In(permisosMasivos.name, action, state);

            let itemToDeleteIndex = state.permisos.findIndex(x => x.id == action.idPermiso)

            let temp = JSON.parse(JSON.stringify(state.permisos));
            temp.splice(itemToDeleteIndex, 1)

            sessionStorage.setItem('PantallaCambios', true);
            result = {
                ...state,
                permisos: temp
            };

            break;

        case SELECT_PRODUCTO_PERMISOSMASIVOS:
            LogHelper.In(permisosMasivos.name, action, state);

            estado = JSON.parse(JSON.stringify(state));

            funciones = [];
            indexToRemove = [];
            action.result.funciones.forEach(function (funcion) {
                funciones.push({
                    id: funcion.Id,
                    descripcion: funcion.Descripcion
                });
            });

            //Rearmo los combos y los checks
            estado.permisos.find(x => x.id == action.result.idPermiso).productoId = action.result.id;
            estado.permisos.find(x => x.id == action.result.idPermiso).categoriaId = 0;
            estado.permisos.find(x => x.id == action.result.idPermiso).programaId = 0;
            estado.permisos.find(x => x.id == action.result.idPermiso).listaFunciones = [];

            //Elimino del permiso las funciones que no est�n en la nueva lista de checks
            estado.permisos.find(x => x.id == action.result.idPermiso).funciones.forEach(function (funcion, index) {
                if (!funciones.find(x => x.id == funcion.id)) {
                    indexToRemove.unshift({ index });
                }
            });

            indexToRemove.forEach(function (i) {
                estado.permisos.find(x => x.id == action.result.idPermiso).funciones.splice(i.index, 1);
            });

            sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                permisos: estado.permisos
            };

            break;

        case SELECT_CATEGORIA_PERMISOSMASIVOS:
            LogHelper.In(permisosMasivos.name, action, state);

            estado = JSON.parse(JSON.stringify(state));

            funciones = [];
            action.result.funciones.forEach(function (funcion) {
                funciones.push({
                    id: funcion.Id,
                    descripcion: funcion.Descripcion
                });
            })

            //Rearmo los combos y los checks
            estado.permisos.find(x => x.id == action.result.idPermiso).categoriaId = action.result.id;
            estado.permisos.find(x => x.id == action.result.idPermiso).programaId = 0;
            estado.permisos.find(x => x.id == action.result.idPermiso).listaFunciones = [];

            //Elimino del permiso las funciones que no est�n en la nueva lista de checks
            estado.permisos.find(x => x.id == action.result.idPermiso).funciones.forEach(function (funcion, index) {
                if (!funciones.find(x => x.id == funcion.id)) {
                    indexToRemove.unshift({ index });
                }
            });

            indexToRemove.forEach(function (i) {
                estado.permisos.find(x => x.id == action.result.idPermiso).funciones.splice(i.index, 1);
            });

            sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                permisos: estado.permisos
            };

            break;

        case SELECT_PROGRAMA_PERMISOSMASIVOS:
            LogHelper.In(permisosMasivos.name, action, state);

            estado = JSON.parse(JSON.stringify(state));

            funciones = [];
            action.result.funciones.forEach(function (funcion) {
                funciones.push({
                    id: funcion.Id,
                    descripcion: funcion.Descripcion
                });
            })

            //Rearmo los combos y los checks
            estado.permisos.find(x => x.id == action.result.idPermiso).programaId = action.result.id;

            if (action.result.id == 0) {
                estado.permisos.find(x => x.id == action.result.idPermiso).listaFunciones = [];
            } else {
                estado.permisos.find(x => x.id == action.result.idPermiso).listaFunciones = funciones;
            }

            //Elimino del permiso las funciones que no est�n en la nueva lista de checks
            estado.permisos.find(x => x.id == action.result.idPermiso).funciones.forEach(function (funcion, index) {
                if (!funciones.find(x => x.id == funcion.id)) {
                    indexToRemove.unshift({ index });
                }
            });

            indexToRemove.forEach(function (i) {
                estado.permisos.find(x => x.id == action.result.idPermiso).funciones.splice(i.index, 1);
            });

            sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                permisos: estado.permisos
            };

            break;

        case AGREGAR_TODASFUNCIONES_PERMISOSMASIVOS:
            LogHelper.In(permisosMasivos.name, action, state);

            estado = JSON.parse(JSON.stringify(state));
            estado.permisos.find(x => x.id == action.idPermiso).listaFunciones.forEach(function (funcion) {
                estado.permisos.find(x => x.id == action.idPermiso).funciones.push(funcion);
            });

            sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                permisos: estado.permisos,
                errorMessageFunciones: ""
            };

            break;

        case ELIMINAR_TODASFUNCIONES_PERMISOSMASIVOS:
            LogHelper.In(permisosMasivos.name, action, state);

            estado = JSON.parse(JSON.stringify(state));
            estado.permisos.find(x => x.id == action.idPermiso).funciones = [];

            sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                permisos: estado.permisos
            };

            break;

        case AGREGAR_FUNCION_PERMISOSMASIVOS:
            LogHelper.In(permisosMasivos.name, action, state);

            estado = JSON.parse(JSON.stringify(state));
            estado.permisos.find(x => x.id == action.idPermiso).funciones.push(
                estado.permisos.find(x => x.id == action.idPermiso).listaFunciones.find(x => x.id == action.idFuncion));

                sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                permisos: estado.permisos,
                errorMessageFunciones: ""
            };

            break;

        case ELIMINAR_FUNCION_PERMISOSMASIVOS:
            LogHelper.In(permisosMasivos.name, action, state);

            estado = JSON.parse(JSON.stringify(state));
            estado.permisos.find(x => x.id == action.idPermiso).funciones.splice(
                estado.permisos.find(x => x.id == action.idPermiso).funciones.findIndex(x => x.id == action.idFuncion), 1);

                sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                permisos: estado.permisos
            };

            break;

        case SAVE_PERMISOS_RESULT_PERMISOSMASIVOS:
            LogHelper.In(permisosMasivos.name, action, state);

            result = {
                ...state,
                isFetching: false,
                redirect: true,
                errorMessagePerfilesUsuarios: "",
                errorMessageFunciones: "",
                message: "",
                messageClass: "",
                messageHidden: true
            };
            break;

        case SET_ERROR_MESSAGES_PERMISOSMASIVOS:
            LogHelper.In(permisosMasivos.name, action, state);

            result = {
                ...state,
                isFetching: false,
                errorMessagePerfilesUsuarios: action.messages.perfilesUsuarios,
                errorMessageFunciones: action.messages.funciones,
                message: action.messages.global,
                messageClass: action.messages.globalClass,
                messageHidden: action.messages.globalHidden
            };

            break;

        case ESCONDER_POPUP_PERMISOSMASIVOS:
            LogHelper.In(permisosMasivos.name, action, state);

            result = {
                ...state,
                message: "",
                messageClass: "",
                messageHidden: true
            };
            break;

        case MOSTRAR_MAS_PERFILES_PERMISOS_MASIVOS:
            LogHelper.In(permisosMasivos.name, state, action);

            sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                showProfiles: true,
            };
            break;

        case MOSTRAR_MENOS_PERFILES_PERMISOS_MASIVOS:
            LogHelper.In(permisosMasivos.name, state, action);

            sessionStorage.setItem('PantallaCambios', true);

            result = {
                ...state,
                showProfiles: false,
            };
            break;
        case OPEN_MODAL_PERMISOS_NO_ASIGNADOS:
            result = {
                ...state,
                openModalPermisosNoAsignados: true,
            };
            break;

        default:
            result = {
                ...state
            };
            break;
    }

    LogHelper.Out(permisosMasivos.name, result);

    return result;
}

export default permisosMasivos;